import { client } from './client';
import { endpoints } from './endpoints';

export type FetchFirebaseCustomTokenRequest = void;

export type FetchFirebaseCustomTokenResponse = {
  fireStoreToken: string;
};

export async function fetchFirebaseCustomToken(): Promise<FetchFirebaseCustomTokenResponse> {
  const res = await client.post(endpoints.LT_AUTH_URL);
  return res.data;
}
